export const normalizeString = (value: any): string | undefined => {
  if (typeof value !== "string") {
    return undefined
  }
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : undefined
}

export const normalizeArray = <T>(value: T[] | any): T[] | undefined => {
  return Array.isArray(value) && value.length > 0 ? value : undefined
}

export const preferValue = <T>(blockValue?: T, fallback?: T): T | undefined => {
  if (blockValue === undefined) {
    return fallback
  }
  if (typeof blockValue === "string") {
    const trimmed = blockValue.trim()
    return (trimmed.length > 0 ? blockValue : fallback) as T | undefined
  }
  if (Array.isArray(blockValue)) {
    return blockValue.length > 0 ? blockValue : fallback
  }
  return blockValue
}
